module.exports = __webpack_public_path__ + "img/FINANCIAL_YEAR.bcd24641.svg";